import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./components/Router";
import Unauthorized from "./components/Unauthorized";
import useLoad from "./lib/i18n/hook-load.jsx";
import i18n from "./lib/i18n/i18n.js";
import GetStore from "./store";

export default function AppPartPanel(props) {
    const [isLangSet, setIsLangSet] = React.useState(false);

    if (!isLangSet && !__isBrowser__) {
        i18n.changeLanguage(props.lang);
        setIsLangSet(true);
        return;
    }

    useLoad("panel");

    React.useEffect(() => {
        if (window.SSRJSS && window.SSRJSS.parentElement) {
            window.SSRJSS.parentElement.removeChild(window.SSRJSS);
        }
    }, []);

    if (!isLangSet) {
        i18n.changeLanguage(window.__Language__);
        setIsLangSet(true);
        return null;
    }

    return (
        <Provider store={GetStore()}>
            <ToastContainer position="bottom-right" limit={4} closeOnClick pauseOnFocusLoss pauseOnHover theme="dark" />

            <Unauthorized>
                <Router url={props.url} />
            </Unauthorized>
        </Provider>
    );
}
